import { X } from 'lucide-react'
import pluralize from 'pluralize'

import type { BulkAction } from '@/components/bulk-actions-bar/types'
import { Button } from '@/components/lemmala-design-system/button/button'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

export type { BulkAction } from '@/components/bulk-actions-bar/types'

type BulkActionsBarProps = {
  selectedCount: number
  entityLabel: string
  actions: BulkAction[]
  onClose: () => void
  /** Appended after the count, e.g. "40 downloadable". */
  detail?: string
}

export const BulkActionsBar = ({
  selectedCount,
  entityLabel,
  actions,
  onClose,
  detail,
}: BulkActionsBarProps) => {
  return (
    <div className='fixed bottom-8 left-1/2 z-50 inline-flex -translate-x-1/2 items-center gap-4 rounded-md border border-main-border-heavy bg-main-background-contrast py-2 pl-4 pr-2 shadow-md'>
      <div className='flex items-center gap-3'>
        <span className='text-main-foreground-inverse text-body-default'>
          {pluralize(entityLabel, selectedCount, true)} selected
          {detail && <span className='text-main-foreground-subtle'>, {detail}</span>}
        </span>
        <div className='flex items-center gap-1'>
          {actions.map(({ id, label, onClick, icon }) => (
            <Button key={id ?? label} onClick={onClick}>
              {icon ? <TextWithIcon icon={icon} text={label} className='gap-2' /> : label}
            </Button>
          ))}
        </div>
      </div>
      <Button
        variant='ghost'
        size='icon'
        aria-label='Clear selection'
        className='text-main-foreground-inverse hover:bg-main-background-interactive-primary-default active:bg-main-background-interactive-primary-pressed'
        onClick={onClose}
      >
        <X className='size-4' />
      </Button>
    </div>
  )
}
